import React, { useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Gift, ArrowRight } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';

const WHATSAPP_URL = 'https://wa.me/919663112394?text=Hi!%20I%20saw%20the%2020%25%20discount%20offer%20and%20I%27m%20interested%20in%20getting%20a%20website';

const ExitIntent = () => {
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  const handleMouseLeave = useCallback((e) => {
    if (e.clientY <= 5 && !dismissed && !show) {
      setShow(true);
    }
  }, [dismissed, show]);

  useEffect(() => {
    const alreadyShown = sessionStorage.getItem('exitIntentShown');
    if (alreadyShown) {
      setDismissed(true);
      return;
    }

    document.addEventListener('mouseleave', handleMouseLeave);
    return () => document.removeEventListener('mouseleave', handleMouseLeave);
  }, [handleMouseLeave]);

  const handleDismiss = () => {
    setShow(false);
    setDismissed(true);
    sessionStorage.setItem('exitIntentShown', 'true');
  };

  return (
    <AnimatePresence>
      {show && !dismissed && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="exit-intent-overlay"
          onClick={handleDismiss}
          data-testid="exit-intent-overlay"
        >
          <motion.div
            initial={{ scale: 0.85, opacity: 0, y: 30 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.85, opacity: 0, y: 30 }}
            transition={{ type: 'spring', stiffness: 300, damping: 25 }}
            className="bg-white rounded-3xl shadow-2xl p-8 max-w-md mx-4 relative"
            onClick={(e) => e.stopPropagation()}
            data-testid="exit-intent-modal"
          >
            <button
              onClick={handleDismiss}
              className="absolute top-4 right-4 text-neutral-400 hover:text-neutral-600"
              data-testid="exit-intent-close"
              aria-label="Close popup"
            >
              <X className="w-5 h-5" />
            </button>

            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-5 bg-gradient-to-br from-primary-500 to-secondary-500 rounded-2xl flex items-center justify-center">
                <Gift className="w-8 h-8 text-white" />
              </div>

              <h3 className="font-heading text-2xl font-bold text-neutral-900 mb-2">
                Wait! Get 20% Off
              </h3>
              <p className="text-neutral-500 mb-6">
                Book your website today and get a <span className="font-bold text-secondary-500">20% discount</span> on your first month. Limited time offer!
              </p>

              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-whatsapp w-full justify-center mb-3"
                data-testid="exit-intent-whatsapp-cta"
              >
                <FaWhatsapp className="w-5 h-5" />
                Claim on WhatsApp
                <ArrowRight className="w-4 h-4" />
              </a>

              <button
                onClick={handleDismiss}
                className="text-sm text-neutral-400 hover:text-neutral-600 transition-colors"
                data-testid="exit-intent-no-thanks"
              >
                No thanks, I'll pass
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ExitIntent;
